import { DigitalInvoiceThanksVideoLink } from '../../Configs/Links';
import { OpenLinkAfterAsyncAction } from '../Misc/Links';

// Redirects to the digital invoice "thank you" page after a contract is
// associated/edited with digital invoice turned on, unless a campaign modal
// (like DejalaIr) was shown instead.
export const openDigitalInvoiceThanksPage = async ({
  wasDigitalInvoiceActive,
  shouldRedirect,
  contractId,
  validateCampaign
}) => {
  let showedCampaignModal = false;
  if (!wasDigitalInvoiceActive && validateCampaign) {
    showedCampaignModal = await validateCampaign(contractId);
  }

  if (showedCampaignModal || !shouldRedirect) {
    return;
  }

  OpenLinkAfterAsyncAction(DigitalInvoiceThanksVideoLink);
};
